'use strict';

+function ($) {

  $.fn.progressStep = function (option) {
    return this.each(function () {
      var $steps = $(this);
      var linear = $steps.attr('data-progress-steps') === 'linear';
      var $current, $next;

      // accordion steps: .accordion-heading.complete, .accordion-heading.active, .accordion-heading.disabled
      if ($steps.hasClass('accordion-group')) {
        $current = $steps.find('.accordion > [data-toggle].active');
        switch (option) {
        case 'back':
          $next = $current.closest('.accordion').prev().find('> [data-toggle]');
          $steps.find('.collapse').not($next.next('.collapse')).collapse('hide');
          $current.toggleClass('disabled', linear);
          $next.removeClass('disabled').click();
          if (linear) {
            $current.removeClass('complete');
            $next.removeClass('complete');
          }
          break;
        case 'next':
          $next = $current.closest('.accordion').next().find('> [data-toggle]');
          $steps.find('.collapse').not($next.find('.collapse')).collapse('hide');
          $current.addClass('complete').toggleClass('disabled', linear);
          $next.removeClass('disabled').click();
          break;
        case 'complete':
          $steps.find('> .accordion > [data-toggle]').addClass('complete');
          $steps.find('> .accordion:last-child > [data-toggle]').removeClass('disabled').click();
          $steps.find('> .accordion:not(:last-child) > [data-toggle]').toggleClass('disabled', linear);
          break;
        case 'reset':
          $steps.find('> .accordion > [data-toggle]').removeClass('complete');
          $steps.find('> .accordion:first-child > [data-toggle]').removeClass('disabled').click();
          $steps.find('> .accordion:not(:first-child) > [data-toggle]').addClass('disabled');
          break;
        }
      // tabbed steps: li.active, li.disabled, li.complete
      } else if ($steps.hasClass('nav-tabs')) {
        $current = $steps.find('> li.active').toggleClass('disabled', linear);
        // Prevent two tabs opening at the same time by first checking if the component is busy
        switch (option) {
        case 'back':
          // check if still busy
          if ($steps.data('busy')) return false;
          $steps.data('busy', true);
          // do the step change
          $next = $current.prev();
          if (linear) {
            $current.removeClass('complete');
            $next.removeClass('complete').removeClass('disabled');
          }
          $next.find('[data-toggle]').click();
          // get ready for the next step change
          window.setTimeout(function () {
            $steps.data('busy', false);
          }, 300);
          break;
        case 'next':
          // check if still busy
          if ($steps.data('busy')) return false;
          $steps.data('busy', true);
          // do the step change
          $next = $current.next().removeClass('disabled');
          $next.find('[data-toggle]').click();
          // get ready for the next step change
          window.setTimeout(function () {
            $steps.data('busy', false);
          }, 300);
          break;
        case 'complete':
          $steps.find('> li').addClass('complete');
          $steps.find('> li:last-child').removeClass('disabled').find('[data-toggle]').click();
          $steps.find('> li:not(:last-child)').toggleClass('disabled', linear);
          break;
        case 'reset':
          $steps.find('> li').removeClass('complete');
          $steps.find('> li:first-child').removeClass('disabled').find('[data-toggle]').click();
          $steps.find('> li:not(:first-child)').addClass('disabled');
          break;
        }
      }
    });
  };

  $(document)
  .on('back.bc.progressStep', function (e) { $(e.target).progressStep('back'); })
  .on('next.bc.progressStep', function (e) { $(e.target).progressStep('next'); })
  .on('complete.bc.progressStep', function (e) { $(e.target).progressStep('complete'); })
  .on('reset.bc.progressStep', function (e) { $(e.target).progressStep('reset'); });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/progress-step.js
// module id = 13
// module chunks = 0